import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here

import Localization from "../../Localization.jsx"
import Config from "../../Config.jsx"
import LocaleViewerPage from "../../pages/LocaleViewerPage.jsx"

import { Box, Drawer, Button, Select, TextInput, ActionIcon, Tooltip, NavLink, Stack, Group } from '@mantine/core';
import { BRAND_PRIMARY } from "../../theme/brandTheme.js";

// icons
import {
  IconSearch,
  IconList,
  IconMap,
  IconCirclePlus,
  IconRefresh,
  IconBookmarks,
  IconX,
} from '@tabler/icons-react';



// List for API request

import SchoolList from "../SchoolList.jsx"
import UserList from "../UserList.jsx"


// drawer width in pixel
const drawerWidthExpanded = 180;
const drawerWidthCollapsed = 54;
const searchDrawerWidth = 350;


const styles = {
  localeFilter: {
    display:'inline-block',
    verticalAlign:'middle',
    padding: '0 15px',
    width: '100%', 
  },
};

class LocaleViewerBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      localeSort: 0,
      localeSortField: "epack.id",
      localeSortOrder: "DESC",
      filterKLA: 0,
      filterSubject: 0,
      filterSubmission: 0,
      searchText: "",
      userOption: 0,
      userList: [],
      mySchoolId: this.props.root.getMySchoolId(),

      isDrawerOpen: true,
      isSearchDrawerOpen: false,
    };
    autoBind(this);

    this.getUserListBySchoolId(this.state.mySchoolId);
  }

  createLocale() {
    // When subscription enforcement is disabled, allow creating directly
    if (typeof Config.SUBSCRIPTION_FLAG === 'function' && Config.SUBSCRIPTION_FLAG() !== true) {
      this.props.root.setCurrentLocale(null);
      this.props.parent.refs.createLocaleDialog.setState({open: true});
      return;
    }

    // Otherwise check remaining locale quota
    const schoolId = this.props.root.getMySchoolId();
    if (!schoolId) {
      console.warn("createLocale: school_id not loaded yet");
      return;
    }

    let requestObj = {
      school_id: schoolId
    }
    this.props.root.refs.API.request("get_epack_quota", requestObj, this.getEpackQuotaOK, this.getEpackQuotaFailed);
  }

  getEpackQuotaOK(res) {
    const availableQuota = parseInt(res.body?.result?.epack_quotas, 10) || 0;
    console.log("available locale quota: ", availableQuota);
    // Only enforce when subscription flag is enabled
    if ((typeof Config.SUBSCRIPTION_FLAG === 'function' && Config.SUBSCRIPTION_FLAG() === true) && availableQuota <= 0) {
      // Prefer showing a dialog similar to storage limit flow
      if (this.props.root && this.props.root.refs && this.props.root.refs.confirmDialog) {
        const subscriptionLinkEnabled = (typeof Config.SUBSCRIPTION_LINK_FLAG === 'function' && Config.SUBSCRIPTION_LINK_FLAG() === true);
        const subscriptionUrl = (typeof Config.SUBSCRIPTION_MANAGE_URL === 'function')
          ? Config.SUBSCRIPTION_MANAGE_URL()
          : (window.location.origin + '/');
        this.props.root.refs.confirmDialog.show(
          {
            title: Localization.strings.LOCALE_LIMIT_REACHED,
            content: Localization.strings.LOCALE_LIMIT_MESSAGE,
            confirm: subscriptionLinkEnabled ? Localization.strings.OPEN_SUBSCRIPTION_PAGE : Localization.strings.CONFIRM,
            cancel: Localization.strings.CLOSE,
          },
          () => {
            if (subscriptionLinkEnabled) {
              window.open(subscriptionUrl, '_blank', 'noopener,noreferrer');
            }
          },
          () => {}
        );
      } else {
        // Fallback to notification
        this.props.root.addNotification(Localization.strings.LOCALE_LIMIT_MESSAGE, false);
      }
    }else{
      this.props.root.setCurrentLocale(null);
      this.props.parent.refs.createLocaleDialog.setState({open: true});
    }
  }

  getEpackQuotaFailed(err) {
    console.log("getEpackQuotaFailed", err);
  }

  refreshLocale() {
    this.props.parent.refreshLocaleList();
  }

  filterKLAChanged(e) {
    this.setState({
      filterKLA: e.target.value
    });
    this.state.filterKLA = e.target.value;

    this.setState({ filterSubject: 0 });
    this.state.filterSubject = 0;
    this.props.parent.filterLocaleByKLA(this.state.filterKLA);
  }

  filterSubjectChanged(e) {
    this.setState({
      filterSubject: e.target.value
    });
    this.state.filterSubject = e.target.value;
    this.props.parent.filterLocaleBySubject(this.state.filterSubject);
  }

  filterSubmissionChanged(e) {
    this.setState({
      filterSubmission: e.target.value
    });
    this.state.filterSubmission = e.target.value;

    this.props.parent.filterLocaleBySubmission(this.state.filterSubmission);
  }

  searchTextChanged(e) {
    this.setState({ searchText: e.target.value });
    this.state.searchText = e.target.value;
  }

  handleSearchClicked() {
    // this.props.parent.filterLocaleByKeyword(this.state.searchText);
    this.props.parent.refreshLocaleList();
    this.dismissSearchDrawer();
  }

  handleSearchEnterPressed(e) {
    if (e.key === "Enter") {
      this.handleSearchClicked();
    }
  }

  showPublicOnlyChanged(e) {
    this.props.parent.setState({ showPublicOnly: e.target.value });
    this.props.parent.state.showPublicOnly = e.target.value;
    this.props.parent.changePage(0);
  }

  clearFilter() {
    this.setState({
      searchText: "",
      filterKLA: 0,
      filterSubject: 0,
      filterSubmission: 0,
    });
    this.state.searchText = "";
    this.state.filterKLA = 0;
    this.state.filterSubject = 0;
    this.state.filterSubmission = 0;

    if (this.refs.schoolList != null) {
      //this.refs.schoolList.onInputChanged(null, "", "");
    }

    if (this.props.parent.onClearFilter) {
      this.props.parent.onClearFilter();
    }
  }

  handleClearClicked() {
    this.clearFilter();
    
    // this.refreshLocale();
    // this.dismissSearchDrawer();
  }

  localeSortChanged(e) {
    let sortField = "epack.id";
    let sortOrder = "DESC";
    switch (e.target.value) {
      case 0:
        sortField = "epack.date_created";
        sortOrder = "DESC";
        break;
      case 1:
        sortField = "epack.date_created";
        sortOrder = "ASC";
        break;
      case 2:
        sortField = "epack.date_update";
        sortOrder = "DESC";
        break;
      case 3:
        sortField = "epack.date_update";
        sortOrder = "ASC";
        break;
      case 4:
        sortField = "epack.name";
        sortOrder = "ASC";
        break;
      case 5:
        sortField = "epack.download_count";
        sortOrder = "DESC";
        break;
      case 6:
        sortField = "epack.download_count";
        sortOrder = "ASC";
        break;
      default:
        break;
    }
    this.setState({
      localeSort: e.target.value,
      localeSortField: sortField,
      localeSortOrder: sortOrder,
    })
    this.state.localeSort = e.target.value;
    this.state.localeSortField = sortField;
    this.state.localeSortOrder = sortOrder;

    // this.refreshLocale();
  }

  onSchoolSelected(school) {
    this.props.parent.changePage(0, false);
    if (school != null) {
      this.props.parent.setState({ filterSchoolID: school.value });
      this.props.parent.state.filterSchoolID = school.value;
    }
    else {
      this.props.parent.setState({ filterSchoolID: null });
      this.props.parent.state.filterSchoolID = null;
    }

    // this.refreshLocale();
  }

  getUserListBySchoolId(schoolId) {
    // Safety check for API ref
    if (!this.props.root.refs || !this.props.root.refs.API) {
      console.warn('API ref not available yet, skipping getUserListBySchoolId');
      return;
    }
    
    var requestObj = {school_id: schoolId};
    this.props.root.refs.API.request("get_user_data_by_school_id", requestObj, this.getUserListOK, this.getUserListFailed);
  }

  getUserListOK(res) {
    // Guard the result (may be null/non-array on the OK path) and mirror it onto state
    // synchronously — setState is async, so setDefaultUserOption below would otherwise read
    // the stale (empty) userList and never select the default user.
    const list = Array.isArray(res && res.body && res.body['result']) ? res.body['result'] : [];
    this.setState({userList: list});
    this.state.userList = list;
    this.setDefaultUserOption(this.props.root.getMyUserId());
  }

  getUserListFailed(err) {
    console.log("getUserListFailed");
  }

  setDefaultUserOption(userId) {
    let option = 0;

    if (!Array.isArray(this.state.userList)) { return; }
    for (var i = 0; i < this.state.userList.length; i++) {
      if (this.state.userList[i]['id'] == userId) {
        option = i;
      }
    }

    this.setState({ userOption: option });
    this.state.userOption = option;
  }

  userOptionChanged(e) {
    let index = e.target.value;
    this.setState({ userOption: index });
    this.state.userOption = index;

    this.clearFilter();

    if (index < 0) {
      this.props.parent.filterLocaleBySchoolAndUserId(this.state.mySchoolId, null);
    }
    else {
      let userId = this.state.userList[index]['id'];
      this.props.parent.filterLocaleBySchoolAndUserId(this.state.mySchoolId, userId);
    }
  }

  handleDrawerOpen = () => {
    this.setState({ isDrawerOpen: true });
  };

  handleDrawerClose = () => {
    if (!this.state.isSearchDrawerOpen) {
      this.setState({ isDrawerOpen: false });
    }
  };

  toggleDrawer = () => {
    this.setState((prevState) => ({ isDrawerOpen: !prevState.isDrawerOpen }));
  };
  handleSearchClick = () => {
    this.setState(prevState => ({ isSearchDrawerOpen: !prevState.isSearchDrawerOpen }));
  };
  
  dismissSearchDrawer = () => {
    console.log("dismissSearchDrawer");
    this.setState({ isSearchDrawerOpen: false });
  };
  


  render() {
      return (
        <div>
          <div ref="div" style={{display:"none",  padding:"10px 0 10px 10px", backgroundColor:"#e0e0e0"}}>

            <Button
              variant="default"
              className="margin-sm"
              onClick={this.createLocale}
              leftSection={<IconCirclePlus size={18} />}
            >
              {Localization.strings.NEW_LOCALE}
            </Button>


            <Button
              className="margin-sm"
              onClick={this.refreshLocale}
              leftSection={<IconRefresh size={18} />}
            >
              {Localization.strings.REFRESH}
            </Button>

            <Switch condition={this.props.parent?.state?.currentView}>
              <Case value={0}>
                <Button
                  className="margin-sm"
                  onClick={()=>this.props.parent.changeView(1)}
                  leftSection={<IconMap size={18} />}
                >
                  {Localization.strings.SWITCH_TO_MAP}
                </Button>
              </Case>
              <Case value={1}>
                <Button
                  className="margin-sm"
                  onClick={()=>this.props.parent.changeView(0)}
                  leftSection={<IconList size={18} />}
                >
                  {Localization.strings.SWITCH_TO_LIST}
                </Button>
              </Case>
            </Switch>

            <If condition={this.props.root.isAdminUser()}>
              <Then>
                <div style={styles.localeFilter}>
                  <Select
                    style={{ width: 150 }}
                    label={Localization.strings.PUBLIC_LOCALE_ONLY}
                    allowDeselect={false}
                    value={String(this.props.parent?.state?.showPublicOnly)}
                    onChange={(v) => this.showPublicOnlyChanged({ target: { value: Number(v) } })}
                    data={[
                      { value: "1", label: Localization.strings.YES },
                      { value: "0", label: Localization.strings.NO },
                    ]}
                  />
                </div>
                <div style={styles.localeFilter}>
                  <Select
                    style={{ width: 80 }}
                    label={Localization.strings.QA_STATE}
                    allowDeselect={false}
                    value={String(this.props.parent?.state?.qaState)}
                    onChange={(v) => this.props.parent.onQAStateChanged({ target: { value: Number(v) } })}
                    data={[
                      { value: "-1", label: Localization.strings.QA_STATE_ANY },
                      { value: "0", label: Localization.strings.QA_STATE_UNCHECKED },
                      { value: "1", label: Localization.strings.QA_STATE_CHECKED },
                      { value: "2", label: Localization.strings.QA_STATE_MINOR },
                      { value: "3", label: Localization.strings.QA_STATE_MAJOR },
                    ]}
                  />
                </div>
              </Then>
            </If>

            <div style={styles.localeFilter}>
              <Select
                label={Localization.strings.SCHOOL}
                allowDeselect={false}
                value={String(this.props.parent?.state?.isViewPublic? 1 : 0)}
                onChange={(v) => this.props.parent.onViewAngleChanged({ target: { value: Number(v) } })}
                data={[
                  { value: "0", label: Localization.strings.MY_SCHOOL },
                  { value: "1", label: Localization.strings.ALL_SCHOOLS },
                ]}
              />
            </div>
            <If condition={this.props.parent?.state?.isViewPublic}>
              <Then>
                <div style={styles.localeFilter}>
                  <SchoolList parent={this} root={this.props.root} ref="schoolList"
                    onSchoolSelected={this.onSchoolSelected}
                  />
                </div>
              </Then>
            </If>

            <If condition={!this.props.parent?.state?.isViewPublic}>
              <Then>
                <div style={styles.localeFilter}>
                  <UserList parent={this} root={this.props.root}
                    userOption={this.state.userOption}
                    userList={this.state.userList}
                  />
                </div>
              </Then>
            </If>

            <div style={styles.localeFilter}>
              <Select
                label={Localization.strings.SORT_BY}
                allowDeselect={false}
                value={String(this.state.localeSort)}
                onChange={(v) => this.localeSortChanged({ target: { value: Number(v) } })}
                data={[
                  { value: "0", label: Localization.strings.SORT_CREATE_DATE_DESC },
                  { value: "1", label: Localization.strings.SORT_CREATE_DATE_ASC },
                  { value: "2", label: Localization.strings.SORT_MODIFY_DATE_DESC },
                  { value: "3", label: Localization.strings.SORT_MODIFY_DATE_ASC },
                  { value: "4", label: Localization.strings.SORT_NAME_ASC },
                  { value: "5", label: Localization.strings.SORT_DOWNLOAD_COUNT_DESC },
                  { value: "6", label: Localization.strings.SORT_DOWNLOAD_COUNT_ASC },
                ]}
              />
            </div>
            <div style={styles.localeFilter}>
              <Select
                label={Localization.strings.KLA_SHORT}
                allowDeselect={false}
                value={String(this.state.filterKLA)}
                onChange={(v) => this.filterKLAChanged({ target: { value: Number(v) } })}
                data={(this.props.root.refs.userDataProfile?.state?.kla || []).map( (row, i) => ({
                  value: String(row['id']),
                  label: row[Localization.strings.getLanguage() === "en"? 'name_eng' : 'name'],
                }))}
              />
            </div>
            <div style={styles.localeFilter}>
              <Select
                label={Localization.strings.SUBJECT}
                allowDeselect={false}
                value={String(this.state.filterSubject)}
                onChange={(v) => this.filterSubjectChanged({ target: { value: Number(v) } })}
                data={[
                  { value: "0", label: Localization.strings.UNSPECIFIED_SUBJECT },
                  ...(this.props.root.refs.userDataProfile?.state?.subject || []).reduce( (acc, row, i) => {
                    if (this.state.filterKLA > 0 && parseInt(row['kla_id']) === this.state.filterKLA) {
                      acc.push({ value: String(i+1), label: row[Localization.strings.getLanguage() === "en"? 'name_eng' : 'name'] });
                    }
                    return acc;
                  }, []),
                ]}
              />
            </div>
            <div style={styles.localeFilter}>
              <Select
                style={{ width: "160px" }}
                label={Localization.strings.OWN_SUBMISSION}
                allowDeselect={false}
                value={String(this.state.filterSubmission)}
                onChange={(v) => this.filterSubmissionChanged({ target: { value: Number(v) } })}
                data={[
                  { value: "1", label: Localization.strings.YES },
                  { value: "0", label: Localization.strings.NO },
                ]}
              />
            </div>
            <div style={styles.localeFilter}>
              <TextInput
                size="sm"
                value={this.state.searchText}
                onChange={this.searchTextChanged}
                label={Localization.strings.SEARCH}
                placeholder={Localization.strings.LOCALE_SEARCH_TEXT_PLACEHOLDER}
                onKeyPress={this.handleSearchEnterPressed}
              />
            </div>
            <Tooltip label={Localization.strings.SEARCH} style={{top:"3px"}}>
              <ActionIcon
                variant="subtle"
                onClick={this.handleSearchClicked}
              >
                <IconSearch size={18} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label={Localization.strings.CLEAR} style={{top:"3px"}}>
              <ActionIcon
                variant="subtle"
                onClick={this.handleClearClicked}
              >
                <IconX size={18} />
              </ActionIcon>
            </Tooltip>
          </div>

          {/* =============== */}
          {/* NEW Drawer code */}
          {/* =============== */}
          <div>
                    
        {/* temp code for drawer testing */}
            <Box
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                height: '100%',
                width: this.state.isDrawerOpen ? `${drawerWidthExpanded}px` : `${drawerWidthCollapsed}px`,
                flexShrink: 0,
                overflowX: 'hidden',
                transition: 'width 0.2s',
                zIndex: 1050, // Set z-index below TopBar (1100) but above most content
                paddingTop: '64px', // Push content below TopBar while background extends to top
                backgroundColor: '#ffffff',
                borderRight: '1px solid rgba(0, 0, 0, 0.12)',
              }}
            >
            <Stack gap={0}>
                {/* create LOCALE */}
                <Box style={{ padding: '10px' }}>
                  <Button
                    onClick={this.createLocale}
                    fullWidth
                    variant="filled"
                    color="brand"
                  >
                    {this.state.isDrawerOpen
                      ? Localization.strings.CREATE_NEW_LOCALE
                      : <IconCirclePlus size={18} />}
                  </Button>
                </Box>
                {/* Change to list view */}
                <NavLink
                  active={this.props.parent?.state?.currentView === 0}
                  onClick={()=>this.props.parent.changeView(0)}
                  leftSection={
                    <IconList style={{
                      color: this.props.parent?.state?.currentView === 0
                        ? BRAND_PRIMARY
                        : 'inherit'
                    }} />
                  }
                  label={this.state.isDrawerOpen ? Localization.strings.LIST_VIEW : "-"}
                />
                {/* change to Map view  */}
                <NavLink
                  active={this.props.parent?.state?.currentView === 1}
                  onClick={()=>this.props.parent.changeView(1)}
                  leftSection={
                    <IconMap style={{
                      color: this.props.parent?.state?.currentView === 1
                        ? BRAND_PRIMARY
                        : 'inherit'
                    }} />
                  }
                  label={this.state.isDrawerOpen ? Localization.strings.MAP_VIEW : "-"}
                />
                {/* change to Resource Library view  */}
                <NavLink
                  active={this.props.parent?.state?.currentView === 2}
                  onClick={()=>this.props.parent.changeView(2)}
                  leftSection={
                    <IconBookmarks style={{
                      color: this.props.parent?.state?.currentView === 2
                        ? BRAND_PRIMARY
                        : 'inherit'
                    }} />
                  }
                  label={this.state.isDrawerOpen ? Localization.strings.DUPLICATABLE_LIBRARY : "-"}
                />
              </Stack>
            </Box>

            <Drawer
              opened={this.state.isSearchDrawerOpen}
              onClose={this.dismissSearchDrawer}
              position="left"
              withCloseButton={false}
              size={searchDrawerWidth}
              transitionProps={{ duration: 0 }}
              overlayProps={{ backgroundOpacity: 0 }}
              styles={{
                content: {
                  marginLeft: `${drawerWidthExpanded}px`, // Move the drawer to the right of the existing drawer
                  borderLeft: '1px solid rgba(0, 0, 0, 0.1)',
                  paddingTop: '64px', // Push content below TopBar
                },
              }}
            >



                {/* some space here */}
                <Box style={{ padding: '', margin: '10px 0px' }}></Box>

                {/* My SCHOOL or ALL */}
              <Box style={{ padding: '10px', margin: '5px 0px' }}>
                <Select
                  style={{ width: '100%', padding: '0px' }}
                  label={Localization.strings.SCHOOL}
                  allowDeselect={false}
                  value={String(this.props.parent?.state?.isViewPublic? 1 : 0)}
                  onChange={(v) => this.props.parent.onViewAngleChanged({ target: { value: Number(v) } })}
                  data={[
                    { value: "0", label: Localization.strings.MY_SCHOOL },
                    { value: "1", label: Localization.strings.ALL_SCHOOLS },
                  ]}
                />
              </Box>

              {/* School List, when viewing all schools */}
              
              <If condition={this.props.parent?.state?.isViewPublic}>
            <Then>
            <Box style={{ padding: '10px', margin: '15px 0px' }}>
                <SchoolList parent={this} root={this.props.root} ref="schoolList"
                  onSchoolSelected={this.onSchoolSelected}
                />
              </Box>
            </Then>
          </If>
          
                    {/* user list (when viewing my school ) */}
                    <If condition={!this.props.parent?.state?.isViewPublic}>
            <Then>
            <Box style={{ padding: '10px', margin: '15px 0px' }}>
                <UserList parent={this} root={this.props.root}
                  userOption={this.state.userOption}
                  userList={this.state.userList}
                />
              </Box>
            </Then>
          </If>

          {/* KLA box */}
          <Box style={{ padding: '10px', margin: '5px 0px' }}>
            <Select
              style={{ width: '100%', padding: '0px' }}
              label={Localization.strings.KLA_SHORT}
              allowDeselect={false}
              comboboxProps={{ maxHeight: 400 }}
              value={String(this.state.filterKLA)}
              onChange={(v) => this.filterKLAChanged({ target: { value: Number(v) } })}
              data={(this.props.root.refs.userDataProfile?.state?.kla || []).map( (row, i) => ({
                value: String(row['id']),
                label: row[Localization.strings.getLanguage() === "en"? 'name_eng' : 'name'],
              }))}
            />
          </Box>

          {/* Subject box */}
          <Box style={{ padding: '10px', margin: '5px 0px' }}>
            <Select
              style={{ width: '100%', padding: '0px' }}
              label={Localization.strings.SUBJECT}
              allowDeselect={false}
              comboboxProps={{ maxHeight: 400 }}
              value={String(this.state.filterSubject)}
              onChange={(v) => this.filterSubjectChanged({ target: { value: Number(v) } })}
              data={[
                { value: "0", label: Localization.strings.UNSPECIFIED_SUBJECT },
                ...(this.props.root.refs.userDataProfile?.state?.subject || []).reduce( (acc, row, i) => {
                  if (this.state.filterKLA > 0 && parseInt(row['kla_id']) === this.state.filterKLA) {
                    acc.push({ value: String(i+1), label: row[Localization.strings.getLanguage() === "en"? 'name_eng' : 'name'] });
                  }
                  return acc;
                }, []),
              ]}
            />
          </Box>



          {/* Has submitted answers */}
          <Box style={{ padding: '10px', margin: '5px 0px' }}>
            <Select
              style={{ width: '100%', padding: '0px' }}
              label={Localization.strings.OWN_SUBMISSION}
              allowDeselect={false}
              comboboxProps={{ maxHeight: 400 }}
              value={String(this.state.filterSubmission)}
              onChange={(v) => this.filterSubmissionChanged({ target: { value: Number(v) } })}
              data={[
                { value: "1", label: Localization.strings.YES },
                { value: "0", label: Localization.strings.NO },
              ]}
            />
          </Box>

          {/* Search by keywords */}
          <Box style={{ padding: '10px', margin: '5px 0px' }}>
            <TextInput
              style={{ width: '100%', padding: '0px' }}
              size="sm"
              value={this.state.searchText}
              onChange={this.searchTextChanged}
              label={Localization.strings.SEARCH}
              placeholder={Localization.strings.LOCALE_SEARCH_TEXT_PLACEHOLDER}
              onKeyPress={this.handleSearchEnterPressed}
            />
          </Box>


          {/* Sorting / order by */}
          <Box style={{ padding: '10px', margin: '5px 0px' }}>
            <Select
              style={{ width: '100%', padding: '0px' }}
              label={Localization.strings.SORT_BY}
              allowDeselect={false}
              value={String(this.state.localeSort)}
              onChange={(v) => this.localeSortChanged({ target: { value: Number(v) } })}
              data={[
                { value: "0", label: Localization.strings.SORT_CREATE_DATE_DESC },
                { value: "1", label: Localization.strings.SORT_CREATE_DATE_ASC },
                { value: "2", label: Localization.strings.SORT_MODIFY_DATE_DESC },
                { value: "3", label: Localization.strings.SORT_MODIFY_DATE_ASC },
                { value: "4", label: Localization.strings.SORT_NAME_ASC },
                { value: "5", label: Localization.strings.SORT_DOWNLOAD_COUNT_DESC },
                { value: "6", label: Localization.strings.SORT_DOWNLOAD_COUNT_ASC },
              ]}
            />
          </Box>




                {/* search buttons */}
              <Group justify="flex-end" p="xs" style={{ paddingRight: '5px' }}>
                <Button
                  variant="default"
                  onClick={this.handleClearClicked}
                  style={{ flexGrow: 1, margin: '5px', padding: '5px', marginRight: '10px' }}
                >
                  Clear
                </Button>

                <Button
                  onClick={this.handleSearchClicked}
                  style={{ flexGrow: 1, margin: '5px', padding: '5px'}}
                >
                  Search
                </Button>
              </Group>


            </Drawer>


          

          </div>
        </div>

      )
  }
}

export default LocaleViewerBar;
